import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/formatting-rules/{-$mode}/{-$id}')({
  beforeLoad: () => getTitleContextSlice('Formatting Rules'),
});
